import React from 'react';

import Rm3DealRow from './Rm3DealRow';
import { IconBed } from './Rm3Icons';

/**
 * One RM3 card (spec Q22): the sub-heading and the card's bed only when its container has more than one card,
 * then the card's deal rows. A title equal to the container label (rule (d) fell back to it) is not repeated.
 * `meta` (title, bed text) was computed once on the UNFILTERED containers, so a filter never renames a card.
 */
function Rm3Card({ card, meta, containerLabel, showHeading, ribbons, displayOrder, context }) {
    const showTitle = !!meta.title && meta.title !== containerLabel;
    return (
        <div className="rm3-card" data-testid="rm3-card" data-card-id={card.cardId}>
            {showHeading && (showTitle || meta.bedText) && (
                <div className="rm3-card__head">
                    {showTitle && (
                        <div className="rm3-card__title" data-testid="rm3-card-title">
                            <bdi>{meta.title}</bdi>
                        </div>
                    )}
                    {meta.bedText && (
                        <div className="rm3-card__bed" data-testid="rm3-card-bed">
                            <IconBed />
                            <bdi>{meta.bedText}</bdi>
                        </div>
                    )}
                </div>
            )}
            <div className="rm3-card__deals">
                {card.deals.map((deal) => (
                    <Rm3DealRow
                        key={deal.id}
                        deal={deal}
                        ribbon={ribbons.get(deal.id)}
                        roomName={meta.title}
                        displayedOrder={displayOrder.get(deal.id)}
                        context={context}
                    />
                ))}
            </div>
        </div>
    );
}

export default Rm3Card;
